import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { KitchenComponent } from './pages/kitchen/kitchen.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { ProjectComponent } from './pages/project/project.component';
import { CustomerTokenGuard } from './services/guards/customer-token.guard';
import { StorageComponent } from './pages/storage/storage.component';
import { StorageInspirationGuard } from './services/guards/storage-inspiration.guard';
import { environment } from '../environments/environment';
import { Configurators2DComponent } from './pages/configurators-2d/configurators-2d.component';
import { SummaryComponent } from './pages/summary/summary.component';
import { FidelityVoucherPublicAccessComponent } from './pages/fidelity/fidelity-customer-details/fidelity-vouchers/fidelity-voucher-public-access/fidelity-voucher-public-access.component';
import { BathroomConfiguratorChoiceComponent } from './pages/bathroom-configurator-choice/bathroom-configurator-choice.component';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: 'cuisine',
    children: [
      { path: '', component: KitchenComponent },
      { path: 'configuration', component: ConfigurationComponent },
      { path: 'recapitulatif', component: SummaryComponent },
    ],
  },
  {
    path: 'rangements',
    children: [
      { path: '', component: StorageComponent },
      { path: 'inspiration', component: StorageComponent, canActivate: [StorageInspirationGuard] },
      { path: 'configuration', component: ConfigurationComponent },
    ],
  },
  {
    path: 'salle-de-bain',
    children: [
      { path: '', component: BathroomConfiguratorChoiceComponent },
      { path: 'configuration', component: ConfigurationComponent },
    ],
  },
  {
    path: 'projects',
    children: [{ path: ':projectUUID', component: ProjectComponent, canActivate: [CustomerTokenGuard] }],
  },
  { path: 'voucher/:token', component: FidelityVoucherPublicAccessComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {
  constructor(private readonly router: Router) {
    Object.entries(environment.configurators2d.applications).forEach(([, app]) => {
      // Ajout des context enfant
      let appChildren = app['children'];
      if (appChildren) {
        appChildren.forEach(child => this.addConfigurator(child.routeUrl));
      } else {
        this.addConfigurator(app.routeUrl);
      }
    });
  }

  addConfigurator(routeUrl: string) {
    this.router.config.push({
      path: routeUrl,
      children: [
        { path: 'configuration', component: Configurators2DComponent },
        {
          path: 'open',
          children: [{ path: ':projectId', component: Configurators2DComponent }],
        },
      ],
    });
  }
}
